// Prefers runtime config placed on window.__APP_CONFIG__; falls back to Vite env.

type ENV = {
  API_URL?: string;
  CLIENT_ID?: string;
  CLIENT_SCOPE?: string;
  AUTHORITY?: string;
  REDIRECT_URI?: string;
};

function fromWindow(): ENV {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return ((window as any).__APP_CONFIG__ ?? {}) as ENV;
}

// Helpers for URL joining
function trimTrailingSlash(s: string) {
  if (!s) return s;
  return s === "/" ? "/" : s.replace(/\/+$/, "");
}
function join(base: string, path: string) {
  return base === "/"
    ? `/${path.replace(/^\/+/, "")}`
    : `${trimTrailingSlash(base)}/${path.replace(/^\/+/, "")}`;
}

export const env = {
  get API_URL() {
    const v = fromWindow()?.API_URL ?? import.meta.env.VITE_API_URL ?? "/";
    return trimTrailingSlash(v);
  },
  get CLIENT_ID() {
    return fromWindow()?.CLIENT_ID ?? import.meta.env.VITE_CLIENT_ID;
  },
  get CLIENT_SCOPE() {
    return fromWindow()?.CLIENT_SCOPE ?? import.meta.env.VITE_CLIENT_SCOPE;
  },
  get AUTHORITY() {
    return fromWindow()?.AUTHORITY ?? import.meta.env.VITE_AUTHORITY;
  },
  get REDIRECT_URI() {
    return fromWindow()?.REDIRECT_URI ?? import.meta.env.VITE_REDIRECT_URI;
  },

  // convenience
  api(path: string) {
    return join(env.API_URL, path);
  },
};
